export namespace AccountConstant {
  export const SIGN_APPLICATION_PREFIX_KEY = 'isAccountAgreementAccepted';
}
